module.exports = __webpack_public_path__ + "assets/img/home_notice.043910f9.png";